export default __webpack_public_path__ + "static/media/whitesmoke.950736d6.png";